import './style.scss';
// import uploadFile from './upload-file'
import DropZone from './dragdrop';

document.addEventListener('DOMContentLoaded', () => {
  let photoForm = document.querySelectorAll('.form--photo')

  photoForm.forEach( ( form ) => {
    
    let ufs = form.querySelectorAll('.upload_image')
    let dpz = new DropZone(form.querySelector('.drop-zone'))

    ufs.forEach( input => {
      input.onchange = (e) => {
        uploadFile( e.target )
      }
    })

    // dpz.input.onchange = (e) => {
    //   uploadFile( e.target )
    // }

    form.addEventListener('submit', function (e) {
      e.preventDefault()
      
      let btn = form.querySelector('button.cta')

      // Build FormData manually to avoid sending heavy files (they already went to S3)
      const fd = new FormData();

      // Ensure AJAX action parameter exists (fallback to photo_form_submit if not in form)
      const actionField = form.querySelector('input[name="action"]');
      fd.append('action', actionField && actionField.value ? actionField.value : 'photo_form_submit');

      // Append all non-file controls; skip unchecked radios/checkboxes
      for (const el of Array.from(form.elements)) {
        if (!el.name) continue;
        const type = (el.type || '').toLowerCase();
        if (type === 'file') continue; // do not send files — we use preupload to S3
        if ((type === 'checkbox' || type === 'radio') && !el.checked) continue;
        if (el.name === 'action') continue; // already appended
        fd.append(el.name, el.value);
      }

      // Ensure preupload token is present once
      let tokenInput = form.querySelector('input[name="preupload_token"]');
      if (!tokenInput && typeof dpz?.getToken === 'function') {
        const t = dpz.getToken(); // also creates hidden input inside the form
        tokenInput = form.querySelector('input[name="preupload_token"]');
        if (!tokenInput) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'preupload_token';
          hidden.value = t;
          form.appendChild(hidden);
          tokenInput = hidden;
        }
      }
      if (tokenInput && tokenInput.value) {
        fd.set('preupload_token', tokenInput.value);
      }

      // Optional UX: disable button during submit
      const originalText = btn.textContent;
      btn.textContent = 'Sending...';
      btn.disabled = true;

      fetch(_wpObject.ajaxUrl, {
        method: 'POST',
        body: fd,
        headers: {
          'X-WP-Nonce': _wpObject.nonce
        }
      })
        .then(res => res.json())
        .then(response => {
          console.log(response);
          if (response.success) {
            alert(response.data.message);
            form.reset();
            dpz.reset();
            form.querySelector('.drop-zone__list').remove();
          } else {
            alert(response.data.error);
          }
        })
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        })
    } )
  })

  let formValidate = ( form ) => {
    let inputs  = form.querySelectorAll('input[required]')
    let selects = form.querySelectorAll('select[required]')
    let files   = form.querySelectorAll('input[type="file"]')
    let errors  = []

    selects.forEach( (el) => {
      errors.push(validate(el))
    } )
    inputs.forEach( (el) => {
      errors.push(validate(el))
    } )
    files.forEach( (el) => {
      errors.push(validate(el))
    } )

    scroll({
      top: form.offsetTop - 70,
      behavior: "smooth"
    })

    return errors.every( el => el === true ) ? true : false
    
  } 

  let validate = ( el ) => {
    let error = new Error(el)
    
    if (el.value === undefined || '' || null || el.value == 0) {
      error.setMessage('This field is required!')
      error.render()

      el.addEventListener('change', (e) => {
        if ( e.target.value ) {
          validate(e.target)
        }
      })

      return false
    } else if ( el.name == 'phone' && !error.isPhone() ) {
      error.remove()
      error.setMessage('Enter a valid phone number!')
      error.render()

      return false
    } else if ( el.name == 'email' && !error.isEmail() ) {
      error.remove()
      error.setMessage('Enter a valid email address!')
      error.render()

      return false
    } else {
      error.remove()

      return true
    }
  }

  class Error {
    constructor( field ) {
      this.field  = field
      this.parent = field.parentElement
      this.error  = document.createElement('span')
      this.error.classList.add('error')
    }

    setMessage( text ) {
      this.message = text
      this.error.textContent = this.message
    }

    render() {
      if ( this.exists() == false ) {
        this.parent.classList.add('form__field--with-error')
        this.parent.appendChild(this.error)
      }
    }

    remove() {
      if ( this.exists() == true ) {
        this.parent.removeChild(this.parent.querySelector('.error'))
        this.parent.classList.remove('form__field--with-error')
      }
    }

    exists() {
      if ( this.parent.querySelector('.error') == null ) {
        return false
      } else {
        return true
      }
    }

    isPhone() {
      let pattern = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/)
      return pattern.test(this.field.value)
    }

    isEmail() {
      let pattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      return pattern.test(this.field.value)
    }

    isDate() {
      let pattern = new RegExp(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/)
      return pattern.test(this.field.value)
    }
  }

})